/* eslint eqeqeq: "off" */
import React, { useEffect } from "react";
import { Col, Row } from "antd";
// import DashboardLogo from "../../assets/images/dashboard.jpg";
// import Mauritius from "../../assets/images/landing/mauritius.jpg";
// import Kerala from "../../assets/images/benefits/kerala.jpg";
// import Rajastan from "../../assets/images/benefits/rajastan.jpg";
// import Phuket from "../../assets/images/benefits/pucket.jpg";
// import Bali from "../../assets/images/benefits/bali.jpg";
import "./index.css";
import useMedia from "use-media-antd-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { loadDealsList } from "../../store/dashboard/actions";

const NewLaunches = () => {
  const media = useMedia();
  const dispatch = useDispatch();
  const history = useHistory();

  //store integrations

  useEffect(() => {
    dispatch(loadDealsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { deals_list = [] } = useSelector((state) => state.Dashboard);

  const slides =
    deals_list !== undefined &&
    deals_list.queryResult &&
    deals_list.queryResult.length > 0
      ? deals_list.queryResult.map((image, index) => {
          return {
            nights: image.daysAndNights,
            destinationId: image.mainDestinationId,
            title: image.mainDestinationName,
            // key: image.mainDestinationName,
            key: index + 1,
            keyIndex: index + 1,
            imageUrl: image.thumnailImages ? image.thumnailImages : "",
            packageName: image.packageName,
            _id: image.packageId,
          };
        })
      : [];

  // const slides =
  //   dealsImages && dealsImages.length > 0 && dealsImageSlides.length > 0
  //     ? dealsImageSlides.map((data) => {
  //         // const sizes =
  //         const [width, height] =
  //           data.size && data.size.split("x").map((val) => val.trim());

  //         console.log(width, "width");
  //         console.log(height, "height");
  //         const imgHeight = parseFloat(height);
  //         const imgWidth = parseFloat(width);
  //         const url =
  //           data.redirectLink &&
  //           data.redirectLink.replace(
  //             "https://pmtadminapi.mequalsvps.in/files//",
  //             "package-details/"
  //           );
  //         console.log(url, "url");
  //         return {
  //           title: data !== undefined ? data.packageName : "",
  //           sectionId: data !== undefined ? data.sectionId : "",
  //           order: data.order,
  //           key: data.packageName ? data.packageName : "",
  //           redirectLink: url,
  //           id: data._id,
  //           nights: data.nights ? data.nights : "",
  //           height: imgHeight ? imgHeight : "",
  //           width: imgWidth ? imgWidth : "",
  //           size: data.size,
  //           image: data.imageUrl ? data.imageUrl : "",
  //         };
  //       })
  //     : [];

  // const slides = [
  //   {
  //     image: DashboardLogo,
  //     nights: "4 Nights / 5 Days",
  //     title: "Kashmir",
  //     key: "kashmir",
  //   },
  //   {
  //     image: Kerala,
  //     nights: "5 Nights / 6 Days",
  //     title: "Kerala",
  //     key: "kerala",
  //   },
  //   {
  //     image: Rajastan,
  //     nights: "5 Nights / 6 Days",
  //     title: "Rajasthan",
  //     key: "rajasthan",
  //   },
  //   {
  //     image: Phuket,
  //     nights: "5 Nights / 6 Days",
  //     title: "Phuket Krabi",
  //     key: "phuket",
  //   },
  //   {
  //     image: Bali,
  //     nights: "6 Nights / 7 Days",
  //     title: "Bali",
  //     key: "bali",
  //   },
  //   {
  //     image: Mauritius,
  //     nights: "6 Nights / 7 Days",
  //     title: "Mauritius",
  //     key: "mauritius",
  //   },
  // ];

  const renderImage = (item, height) => (
    <div
      style={{
        position: "relative",
        borderRadius: "10px",
        overflow: "hidden",
        height: `${height}px`,
      }}
      // onClick={() => history.push(item.redirectLink)}
      className="hover:scale-105 transition-transform duration-600 cursor-pointer"
    >
      <img
        src={item.imageUrl ? item.imageUrl : ""}
        alt={item.title}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          borderRadius: "10px",
        }}
      />
      <p
        style={{
          position: "absolute",
          top: "0px",
          bottom: "0px",
          //   marginLeft: "1px",
          width: "100%",
          // color: "white",
          fontSize: "18px",
          fontFamily: "Poppins",
          fontWeight: 700,
          //   zIndex: 20,
          padding: "20px",
          background: "#0000002b",
          borderRadius: "8px",
        }}
      ></p>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "12px",
          fontFamily: "Poppins",
          color: "#fff",
        }}
      >
        <h4 style={{ margin: 0 }} className="text-[16px] font-semibold">
          {item.title}
        </h4>
        <p style={{ margin: 0, fontSize: "13px" }}>{item.nights}</p>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24} className="mt-3">
        <Row>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                : "pt-3 pb-3 pl-[80px] pr-[80px]"
            }
            style={{
              fontFamily: "Poppins",
            }}
          >
            <div>
              <h1 className="text-[24px] font-extrabold flex">
                <p className="text-[#eb3a3e] mr-1">Deals</p> You Can't miss
              </h1>
              <p className="text-[15px]  mt-2 font-normal text-start">
                Travel Beyond boundaries with incredible savings
              </p>
              {/* <h1 className="text-[20px] font-semibold">PMT New Launches</h1> */}
            </div>
          </Col>

          <Col
            md={24}
            sm={24}
            xs={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                : "pt-3 pb-3 pl-[80px] pr-[80px]"
            }
          >
            <Row>
              <Row className="w-[100%]" gutter={[16, 16]}>
                {/* Left Section: Kashmir + Kerala + Rajasthan */}
                <Col md={8} xl={8} xxl={8} lg={8} sm={24} xs={24}>
                  <Row gutter={[16, 16]}>
                    <Col
                      onClick={() => {
                        if (
                          slides &&
                          slides.length > 0 &&
                          slides[0].title !== ""
                        ) {
                          history.push({
                            pathname: `/package-details/${
                              slides && slides.length > 0 && slides[0].title
                            }`,
                            state: slides && slides.length > 0 ? slides[0] : {},
                          });
                        }
                      }}
                      md={24}
                      xl={24}
                      xxl={24}
                      lg={24}
                      sm={24}
                      xs={24}
                      className="w-[100%]"
                    >
                      {renderImage(
                        slides && slides.length > 0 && slides[0],
                        256
                      )}
                    </Col>
                    <Col
                      onClick={() => {
                        if (
                          slides &&
                          slides.length > 1 &&
                          slides[1].title !== ""
                        ) {
                          history.push({
                            pathname: `/package-details/${
                              slides && slides.length > 1 && slides[1].title
                            }`,
                            state: slides && slides.length > 1 ? slides[1] : {},
                          });
                        }
                      }}
                      md={12}
                      xl={12}
                      xxl={12}
                      lg={12}
                      sm={24}
                      xs={24}
                      className="w-[100%]"
                    >
                      {renderImage(
                        slides && slides.length > 1 && slides[1],
                        240
                      )}
                    </Col>
                    <Col
                      onClick={() => {
                        if (
                          slides &&
                          slides.length > 2 &&
                          slides[2].title !== ""
                        ) {
                          history.push({
                            pathname: `/package-details/${
                              slides && slides.length > 2 && slides[2].title
                            }`,
                            state: slides && slides.length > 2 ? slides[2] : {},
                          });
                        }
                      }}
                      md={12}
                      xl={12}
                      xxl={12}
                      lg={12}
                      sm={24}
                      xs={24}
                      className="w-[100%]"
                    >
                      {renderImage(
                        slides && slides.length > 2 && slides[2],
                        240
                      )}
                    </Col>
                  </Row>
                </Col>

                {/* Center Section: Phuket Krabi */}
                <Col
                  onClick={() => {
                    if (slides && slides.length > 3 && slides[3].title !== "") {
                      history.push({
                        pathname: `/package-details/${
                          slides && slides.length > 3 && slides[3].title
                        }`,
                        state: slides && slides.length > 3 ? slides[3] : {},
                      });
                    }
                  }}
                  md={8}
                  xl={8}
                  xxl={8}
                  lg={8}
                  sm={24}
                  xs={24}
                  className="w-[100%]"
                >
                  {renderImage(slides && slides.length > 3 && slides[3], 512)}
                </Col>

                {/* Right Section: Bali + Mauritius */}
                <Col md={8} xl={8} xxl={8} lg={8} sm={24} xs={24}>
                  <Row gutter={[16, 16]}>
                    <Col
                      onClick={() => {
                        if (
                          slides &&
                          slides.length > 4 &&
                          slides[4].title !== ""
                        ) {
                          history.push({
                            pathname: `/package-details/${
                              slides && slides.length > 4 && slides[4].title
                            }`,
                            state: slides && slides.length > 4 ? slides[4] : {},
                          });
                        }
                      }}
                      md={24}
                      xl={24}
                      xxl={24}
                      lg={24}
                      sm={24}
                      xs={24}
                      className="w-[100%]"
                    >
                      {renderImage(
                        slides && slides.length > 4 && slides[4],
                        256
                      )}
                    </Col>
                    <Col
                      onClick={() => {
                        if (
                          slides &&
                          slides.length > 5 &&
                          slides[5].title !== ""
                        ) {
                          history.push({
                            pathname: `/package-details/${
                              slides && slides.length > 5 && slides[5].title
                            }`,
                            state: slides && slides.length > 5 ? slides[5] : {},
                          });
                        }
                      }}
                      md={24}
                      xl={24}
                      xxl={24}
                      lg={24}
                      sm={24}
                      xs={24}
                      className="w-[100%]"
                    >
                      {renderImage(
                        slides && slides.length > 5 && slides[5],
                        240
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Row>{" "}
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
export default NewLaunches;
